import React, { useMemo } from 'react'
import { moduleContext } from 'react-contextual'
import { useDispatch, useSelector } from 'react-redux'
import { ROUTES } from 'constants/routes'
import { reportingApiSelectors } from 'modules/api/reporting'
import { layoutEvents } from '../Layout/state'
import { uiEvents } from '../ui'

const SuspenseAccountsProvider = moduleContext()(({ context, children, ...props }: any) => {
  const dispatch = useDispatch()

  const { match } = props
  const { params } = match
  const id = params?.id

  // The lists are paged, sorted and searched by the reporting API; each holds the page on screen.
  const unallocatedList = useSelector(state => reportingApiSelectors.getSuspenseAccountList(state)('unallocated'))
  const allocatedList = useSelector(state => reportingApiSelectors.getSuspenseAccountList(state)('allocated'))

  const currentReference = useMemo(
    () => [...unallocatedList.items, ...allocatedList.items].find(item => item.txId === id),
    [unallocatedList.items, allocatedList.items, id],
  )

  // Counts are each list's total for the current search, not just the page.
  const filters = useMemo(
    () => [
      { key: 'unallocated', label: 'Unallocated', data: unallocatedList.items, count: unallocatedList.total },
      { key: 'allocated', label: 'Allocated', data: allocatedList.items, count: allocatedList.total },
    ],
    [unallocatedList, allocatedList],
  )

  const suspenseAccountsStore = {
    match,
    filters,
    currentReference,
    isLoading: false,
    redirect: (path: any) => dispatch(uiEvents.redirect(path)),
    openReference: (id: any) => {
      dispatch(uiEvents.redirect(ROUTES.suspenseAccountView.replace(':id', id)))
      dispatch(layoutEvents.openPrimaryPanel('suspenseAccounts'))
      dispatch(layoutEvents.closeSidebar('global'))
    },
    closeReference: () => {
      dispatch(uiEvents.redirect(ROUTES.suspenseAccount))
      dispatch(layoutEvents.closePrimaryPanel('suspenseAccounts'))
      dispatch(layoutEvents.openSidebar('global'))
    },
    ...props,
  }
  return <context.Provider value={suspenseAccountsStore}>{children}</context.Provider>
})

export default SuspenseAccountsProvider
